/**
 * @generated SignedSource<<90b0da86f5f183249312c96e231cf165>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatePageInput = {
  name: string;
};
export type PagesListAddMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreatePageInput;
};
export type PagesListAddMutation$data = {
  readonly createPage: {
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"PagesListRow_page">;
    };
  };
};
export type PagesListAddMutation = {
  response: PagesListAddMutation$data;
  variables: PagesListAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PagesListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PageNode",
        "kind": "LinkedField",
        "name": "createPage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PagesListRow_page"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PagesListAddMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "PageNode",
        "kind": "LinkedField",
        "name": "createPage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deletable",
                    "storageKey": null
                  }
                ],
                "type": "Entity",
                "abstractKey": "__isEntity"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "appendNode",
            "key": "",
            "kind": "LinkedHandle",
            "name": "node",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              },
              {
                "kind": "Literal",
                "name": "edgeTypeName",
                "value": "PageEdge"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "26445a2f8ce731d5c08111286abb3d35",
    "id": null,
    "metadata": {},
    "name": "PagesListAddMutation",
    "operationKind": "mutation",
    "text": "mutation PagesListAddMutation(\n  $input: CreatePageInput!\n) {\n  createPage(input: $input) {\n    node {\n      ...PagesListRow_page\n      id\n    }\n  }\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment PagesListRow_page on Page {\n  id\n  name\n  ...SortableEntityTableRow_entity\n}\n\nfragment SortableEntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  ...EntityTableRow_entity\n}\n"
  }
};
})();

(node as any).hash = "9aeb21883b3b30d8fa9b2b0cb1781b71";

export default node;
